export default __webpack_public_path__ + "arrow.svg?cc920b992ad7d12a4603a13153f21c2f";